// Globals
import { useTranslation } from 'react-i18next';

// Components
import { StyledMainTitleWrapper, StyledPageTitle, StyledPageWrapper } from '../../components/Styled';

// Containers
import { CashRegistersContainer } from '../index';

const FinancialSettingsContainer = () => {
  const { t } = useTranslation(['financialSettings']);

  return (
    <StyledPageWrapper>
      <StyledMainTitleWrapper>
        <StyledPageTitle>{t('page_title')}</StyledPageTitle>
      </StyledMainTitleWrapper>

      <CashRegistersContainer />
    </StyledPageWrapper>
  );
};

export default FinancialSettingsContainer;
